import { Box } from '@mui/material'
import React from 'react'
import BasicTab from './BasicTab'
import { Outlet } from 'react-router-dom'

export default function FileTransfer() {
  return (
    <Box>
      <BasicTab/>
      <Outlet/>
    </Box>
  )
}
